if (!customElements.get('m-shipping-info-modal')) {
  customElements.define(
    'm-shipping-info-modal',
    class MShippingInfoModal extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('[data-shipping-info-content]');
        this.trigger = this.querySelector('[data-open-shipping-info]');
        if (!this.template || !this.trigger) return;

        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.openModal();
        });
      }

      openModal() {
        if (window.MinimogTheme && window.MinimogTheme.Modal) {
          if (!this.themeModal) this.themeModal = new MinimogTheme.Modal();
          const modalRoot = this.template.content.querySelector('.av-shipping-modal');
          const colorScheme = (modalRoot && modalRoot.dataset.colorScheme) || '';
          const wrapper = document.createElement('div');
          wrapper.appendChild(this.template.content.cloneNode(true));
          this.themeModal.appendChild(wrapper);
          this.themeModal.setWidth('480px');
          this.themeModal.setSizes(`av-shipping-modal-wrap m-gradient ${colorScheme}`.trim());
          this.themeModal.open();
          return;
        }

        this.openNativeDialog();
      }

      openNativeDialog() {
        document.getElementById('tf-shipping-info-dialog')?.remove();

        const dialog = document.createElement('dialog');
        dialog.id = 'tf-shipping-info-dialog';
        dialog.className = 'tf-shipping-dialog';
        dialog.innerHTML = `
          <div class="tf-shipping-dialog__panel">
            <button type="button" class="tf-shipping-dialog__close" aria-label="Close">&times;</button>
            <div class="tf-shipping-dialog__body"></div>
          </div>
        `;
        dialog.querySelector('.tf-shipping-dialog__body').appendChild(
          this.template.content.cloneNode(true)
        );
        document.body.appendChild(dialog);

        const close = () => {
          dialog.close();
          dialog.remove();
        };
        dialog.querySelector('.tf-shipping-dialog__close').addEventListener('click', close);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) close();
        });
        dialog.addEventListener('close', () => dialog.remove());
        dialog.showModal();
      }
    }
  );
}
